import { action } from 'sky-engine/api/index'

import { POSITION_MNG } from '@/api/apiModules'

export function getSpecPositionList(data) {
  return action(POSITION_MNG, 'list', data)
}

export function getSpecPositionSoftwareList(data) {
  return action(POSITION_MNG, '/software/list', data)
}

export function getSpecPositionPeripheralList(data) {
  return action(POSITION_MNG, '/peripheral/list', data)
}
